import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, MapPin, Phone } from 'lucide-react';
import './styles.scss';

const Contacts = () => {
	const { t } = useTranslation();

	return (
		<section className='contacts'>
			<div className='container'>
				<h1 className='contacts__title'>{t('contacts.title')}</h1>
				<div className='contacts__content'>
					<div className='contacts__info-block'>
						<div className='contacts__info'>
							<ul className='contacts__info-list'>
								<li className='contacts__info-item'>
									{/* {t('contacts.phone')}: */}
									<div className='contacts__phone-list'>
										<div className='contacts__phone-item'>
											<a
												href='tel:+996888558888'
												className='contacts__phone-link'
											>
												<Phone size={20} />
												+996 888 558 888
											</a>
										</div>
										<div className='contacts__phone-item'>
											<div className='contacts__phone-text'>
												<div className='contacts__phone-description'>
													{t('contacts.paymentDepartment')}:
												</div>
												<a
													href='tel:+996220142170'
													className='contacts__phone-link'
												>
													<Phone size={20} />
													+996 220 142 170
												</a>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
						<div className='contacts__info'>
							<ul className='contacts__info-list'>
								<li className='contacts__info-item'>
									{/* {t('contacts.email')}:  */}
									<a className='contacts__info-item' href='mailto:info@envoys.vision'>
										<Mail size={20} /> info@envoys.vision
									</a>
								</li>
								<li className='contacts__info-item'>
									{/* {t('contacts.address')}:  */}
									<MapPin size={20} /> {t('contacts.addressDetails')}
								</li>
							</ul>
						</div>
					</div>
					<div className='contacts__map'>
						<iframe
							title={t('contacts.mapTitle')}
							src='https://yandex.com/map-widget/v1/?um=constructor%3Accabb189460d92caf0e7d2c88a7bd06a5e12cb24bb2b2abe1cc70040990ae953&amp;source=constructor'
							width='100%'
							height='350'
							style={{ border: 0 }}
						></iframe>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Contacts;
